module.exports = __webpack_public_path__ + "media/images/comunicado_pix_2-713e4293c62fe3b3d92e6d2d7e8701cf.png";